import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { rowspan: "rowSpan" }

import DeliveryPlanType from "@/types/DeliveryPlan"


export default /*@__PURE__*/_defineComponent({
  __name: 'EmptyRow',
  props: {
    detailData: {},
    rowSpan: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createElementVNode("td", { rowspan: "rowSpan" }, null, -1)),
    _cache[1] || (_cache[1] = _createElementVNode("td", { rowspan: "rowSpan" }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("td", { rowspan: "rowSpan" }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("td", { rowspan: "rowSpan" }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("td", { rowspan: "rowSpan" }, null, -1)),
    _cache[5] || (_cache[5] = _createElementVNode("td", { rowspan: "rowSpan" }, null, -1)),
    _cache[6] || (_cache[6] = _createElementVNode("td", { rowspan: "rowSpan" }, null, -1)),
    _cache[7] || (_cache[7] = _createElementVNode("td", { rowspan: "rowSpan" }, null, -1)),
    _cache[8] || (_cache[8] = _createElementVNode("td", { rowspan: "rowSpan" }, null, -1)),
    _cache[9] || (_cache[9] = _createElementVNode("td", { rowspan: "rowSpan" }, null, -1)),
    _cache[10] || (_cache[10] = _createElementVNode("td", { rowspan: "rowSpan" }, null, -1)),
    _cache[11] || (_cache[11] = _createElementVNode("td", { rowspan: "rowSpan" }, null, -1)),
    _cache[12] || (_cache[12] = _createElementVNode("td", { rowspan: "rowSpan" }, null, -1)),
    _cache[13] || (_cache[13] = _createElementVNode("td", { rowspan: "rowSpan" }, null, -1)),
    _createElementVNode("td", _hoisted_1, _toDisplayString(props.detailData.leavingDiffTime), 1),
    _cache[14] || (_cache[14] = _createElementVNode("td", { rowspan: "rowSpan" }, null, -1)),
    _cache[15] || (_cache[15] = _createElementVNode("td", { rowspan: "rowSpan" }, null, -1)),
    _cache[16] || (_cache[16] = _createElementVNode("td", { rowspan: "rowSpan" }, null, -1)),
    _cache[17] || (_cache[17] = _createElementVNode("td", { rowspan: "rowSpan" }, null, -1)),
    _cache[18] || (_cache[18] = _createElementVNode("td", null, null, -1))
  ], 64))
}
}

})